import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  deleteFreightClaimAttachmentsCall,
  getOverShortDetails,
  getReceiveDetails,
  getStoreCreditDetails,
  uploadFreightClaimAttachmentsCall
} from "src/api/sp";
import { UploadFreightClaimAttachmentFile } from "src/pages/CreateFreightClaim/interface";

export const fetchOverShortDetails = createAsyncThunk(
  "fetchOverShortDetails",
  ({
    internalReferenceId,
    storeId
  }: {
    internalReferenceId: string;
    storeId: string;
  }) => getOverShortDetails(internalReferenceId, storeId)
);

export const fetchTransferDetails = createAsyncThunk(
  "fetchTransferDetails",
  ({
    docId,
    storeId,
    type
  }: {
    docId: string;
    storeId: string;
    type: string;
  }) => getReceiveDetails("", type, docId, storeId)
);

export const uploadAttachments = createAsyncThunk(
  "uploadAttachments",
  (payload: UploadFreightClaimAttachmentFile) =>
    uploadFreightClaimAttachmentsCall(payload)
);

export const deleteAttachments = createAsyncThunk(
  "deleteAttachments",
  (filePath: string) => {
    deleteFreightClaimAttachmentsCall(filePath);
  }
);
export const getStoreCreditDetailsForOS = createAsyncThunk(
  "getStoreCreditDetailsForOS",
  ({
    storeId,
    referenceTransfer,
    type
  }: {
    storeId: string;
    referenceTransfer: number;
    type: string;
  }) => getStoreCreditDetails({ storeId, referenceTransfer, type })
);
